/* Kun Shafi — Phase 3B · collection-card tilt
   Pointer-driven 3D tilt + parallax + glow. Pure CSS transforms — no GLB, no WebGL, no external module.
   Robust to Shopify section reloads (Dawn build) (MutationObserver + per-node flags).
   Respects prefers-reduced-motion and pointer:coarse. */
(function () {
  'use strict';

  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var coarse = window.matchMedia('(pointer: coarse)').matches;

  // ---------- Collection tilt (Phase 3B) ----------
  function initCollectionTilt(item) {
    if (item.__knTiltInit) return;
    item.__knTiltInit = true;
    if (reduced || coarse) return; // no tilt on touch / reduced-motion → no scaffolding at all

    item.setAttribute('data-kn-tilt', '');

    var imgBox = item.querySelector('.card__media');
    if (imgBox) {
      imgBox.querySelectorAll('.kn-tilt-glow').forEach(function (g) { g.remove(); }); // drop any clone copy
      var glow = document.createElement('div');
      glow.className = 'kn-tilt-glow';
      imgBox.appendChild(glow);
      item.__knGlow = glow;
    }

    var raf = null, pending = null;
    function apply() {
      raf = null;
      if (!pending) return;
      var px = pending.px, py = pending.py;
      var rx = (0.5 - py) * 7;   // rotateX
      var ry = (px - 0.5) * 7;   // rotateY
      item.style.transform = 'perspective(720px) rotateX(' + rx.toFixed(2) + 'deg) rotateY(' + ry.toFixed(2) + 'deg)';
      if (item.__knGlow) {
        item.__knGlow.style.setProperty('--gx', (px * 100).toFixed(1) + '%');
        item.__knGlow.style.setProperty('--gy', (py * 100).toFixed(1) + '%');
      }
    }
    item.addEventListener('pointerenter', function () { item.classList.add('kn-tilting'); });
    item.addEventListener('pointermove', function (e) {
      var r = item.getBoundingClientRect();
      pending = { px: (e.clientX - r.left) / r.width, py: (e.clientY - r.top) / r.height };
      if (!raf) raf = requestAnimationFrame(apply);
    });
    item.addEventListener('pointerleave', function () {
      item.classList.remove('kn-tilting');
      pending = null;
      if (raf) { cancelAnimationFrame(raf); raf = null; }
      item.style.transform = '';
    });
  }

  // ---------- Scan + observe ----------
  function scan(root) {
    var r = root || document;
    if (r.querySelectorAll) {
      r.querySelectorAll('.collection-list__item .card-wrapper, .collection-list li .card-wrapper').forEach(initCollectionTilt);
    }
  }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  }

  ready(function () {
    scan(document);
    if (reduced || coarse) return; // tilt never inits on touch / reduced-motion — skip observer + rescan entirely
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        muts.forEach(function (m) {
          m.addedNodes.forEach(function (n) {
            if (n.nodeType !== 1) return;
            if (n.matches && n.matches('.collection-list__item .card-wrapper')) initCollectionTilt(n);
            scan(n);
          });
        });
      });
      mo.observe(document.body || document.documentElement, { childList: true, subtree: true });
    }
    // Re-scan after slick carousels finish cloning (defensive, cheap)
    setTimeout(function () { scan(document); }, 1200);
  });
})();
